import { useEffect, useState } from 'react';

import { skipToken, useQuery } from '@apollo/client/react';
import dayjs from 'dayjs';

import { CHANNEL_SYNC } from '../graphql';

export const POLLING_INTERVAL = 5000;

const getAfter = () => {
  return dayjs().subtract(POLLING_INTERVAL, 'millisecond').toISOString();
};

export const useGetBannersInterval = ({ storeId }: { storeId?: string }) => {
  const [after, setAfter] = useState(getAfter());
  const { data } = useQuery(
    CHANNEL_SYNC,
    storeId
      ? {
          variables: {
            after: after,
            masterDataStoreId: storeId,
          },
        }
      : skipToken
  );

  useEffect(() => {
    const intervalId = setInterval(() => {
      setAfter(getAfter());
    }, POLLING_INTERVAL);

    return () => clearInterval(intervalId);
  }, []);

  return {
    data,
  };
};
